<!-- eslint-disable vue/no-multiple-template-root -->
<template>
    <slot
        :denied="denied"
        :accepted="!denied"
    ></slot>
</template>
<!-- eslint-enable vue/no-multiple-template-root -->

<script>
export default {
    name: 'AccessLevel',

    props: {
        allowFor: {
            type: Array,
            nullable: true,
            default: null,
        },
        disableFor: {
            type: Array,
            nullable: true,
            default: null,
        },
    },

    computed: {
        denied() {
            let denied = true;

            if (this.$store.getters.isOwnerPlace) {
                denied = false;
            } else if (this.disableFor?.includes('company-readonly')) {
                denied = true;
            } else {
                if (this.disableFor) {
                    const companyDenied = this.disableFor.includes(this.$store.getters.selectedCompany?.company?.role);
                    const placeDenied = this.disableFor.includes(this.$store.getters.selectedPlace?.role);
                    denied = placeDenied || companyDenied;
                } else if (this.allowFor) {
                    const companyAllowed = this.allowFor.includes(this.$store.getters.selectedCompany?.company?.role);
                    const placeAllowed = this.allowFor.includes(this.$store.getters.selectedPlace?.role);
                    const allowed = placeAllowed || companyAllowed;
                    denied = !allowed;
                }
            }

            return denied;
        },
    },
};
</script>
